import { render } from "./Podcasts.vue?vue&type=template&id=144a5b9a&scoped=true"
import script from "./Podcasts.vue?vue&type=script&lang=js"
export * from "./Podcasts.vue?vue&type=script&lang=js"

import "./Podcasts.vue?vue&type=style&index=0&id=144a5b9a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144a5b9a"]])

export default __exports__